import {
  getIconClassName,
  getIconDimension,
  type IconComponentProps
} from "./iconUtils";

export const CaretLineLeftIcon = ({
  className,
  size,
  ...svgProps
}: IconComponentProps): JSX.Element => {
  const dimension = getIconDimension(size);

  return (
    <svg
      fill="none"
      height={dimension}
      viewBox="0 0 16 17"
      width={dimension}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
      className={getIconClassName(className)}
    >
      <path
        d="M4.8002 3.21772C4.8002 2.7759 4.44202 2.41772 4.0002 2.41772C3.55837 2.41772 3.2002 2.7759 3.2002 3.21772V14.2177C3.2002 14.6596 3.55837 15.0177 4.0002 15.0177C4.44202 15.0177 4.8002 14.6596 4.8002 14.2177V3.21772Z"
        fill="currentColor"
      />
      <path
        d="M13.0659 4.78341C13.3783 4.47099 13.3783 3.96446 13.0659 3.65204C12.7535 3.33962 12.2469 3.33962 11.9345 3.65204L7.43451 8.15204C7.12209 8.46446 7.12209 8.97099 7.43451 9.28341L11.9345 13.7834C12.2469 14.0958 12.7535 14.0958 13.0659 13.7834C13.3783 13.471 13.3783 12.9645 13.0659 12.652L9.13157 8.71772L13.0659 4.78341Z"
        fill="currentColor"
      />
    </svg>
  );
};
